import PropTypes from 'prop-types';

const propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  className: PropTypes.string,
};

function Disclosure({ text, className = '' }) {
  if (!text) return null;

  const textArray = Array.isArray(text) ? text : [text];

  return (
    <div className={`footer__disclosure ${className}`.trim()}>
      {/* eslint-disable-next-line react/no-array-index-key */}
      {textArray.map((paragraph, idx) => (
        <p key={`disclosure-${idx}`}>{paragraph}</p>
      ))}
    </div>
  );
}

Disclosure.propTypes = propTypes;

export default Disclosure;

// Copyright © 2025 Micruity Inc.
